module.exports = "#define GLSLIFY 1\nuniform sampler2D positionTexture;\n\nattribute vec4 texLocation;\n\n\nvarying vec3 vForce;\n\nvoid main() {\n  vec3 pos1 = texture2D(positionTexture, texLocation.xy).xyz;\n  vec3 pos2 = texture2D(positionTexture, texLocation.zw).xyz;\n\n  gl_PointSize = 1.;\n\n  vec3 dist = (pos2 - pos1);\n  vForce = dist * 0.005;\n  gl_Position = vec4(texLocation.x * 2. - 1., texLocation.y * 2. - 1., 0., 1.);\n  \n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/pull.vert
// module id = 52
// module chunks = 0